import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import { useDispatch, useSelector } from "react-redux";
import { addLead, resetLead } from "../../redux/actions-exporter";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
import PaymentSuccess from "../repeats/paymentSuccess/PaymentSuccess";
import WhereAndWhen from "../repeats/whereAndWhen/WhereAndWhen";
import PersonalDetails from "../repeats/personalDetails/PersonalDetails";

import bannerImg from "../../assets/images/TII/Two-Movers-With-Box-On-Stairca-97352312.jpg";
import galleryImg1 from "../../assets/images/MT/6.jpg";
import galleryImg2 from "../../assets/images/MT/GettyImages-135385164_pczbmr.jpg";
import galleryImg3 from "../../assets/images/MT/moving-checklist-2000-6ec63f4c4aa94bf9b9cb32f80bfd97a7.jpg";
import galleryImg4 from "../../assets/images/MT/6-Common-Mistakes-to-Avoid-When-Hiring-a-Moving-Company.jpeg";
import galleryImg5 from "../../assets/images/MT/AdobeStock_300477109-min_a23ba322c2da1cd76ade9dd3d3983ed1_2000.jpeg";
import galleryImg6 from "../../assets/images/MT/movers-collegeville.jpg";

const LEAD_SOURCE = "הובלה בעזרת נציג";

const TransportGetBack = ({ mainLogo }) => {
  const dispatch = useDispatch();
  const addedLead = useSelector((state) => state.lead.addedLead);
  const [form, setForm] = useState({ source: LEAD_SOURCE, extraFields: {} });
  const [send, setSend] = useState(false);
  const [validated, setValidated] = useState(false);
  const [fromaddress, setFromaddress] = useState("");
  const [toaddress, setToaddress] = useState("");
  const [moveDate, setMoveDate] = useState("");
  const [start, setStart] = useState(true);
  const galleryArr = [
    {
      img: galleryImg1,
    },
    {
      img: galleryImg2,
    },
    {
      img: galleryImg3,
    },
    {
      img: galleryImg4,
    },
    {
      img: galleryImg5,
    },
    {
      img: galleryImg6,
    },
  ];

  useEffect(() => {
    if (addedLead) {
      setSend(true);
      setForm({ source: LEAD_SOURCE });
      dispatch(resetLead());
    }
  }, [addedLead]); // eslint-disable-line

  const handleSend = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else {
      dispatch(addLead(form, "only_delivery"));
    }
    setValidated(true);
  };

  useEffect(() => {
    if (start || send) document.querySelector(".homeTitle").scrollIntoView();
    setStart(false);
  }, [send]);

  const handleOnPlaceSelected = (place, inputRefTo) => {
    if (inputRefTo.name === "fromaddress") {
      setFromaddress(place.formatted_address);
    } else if (inputRefTo.name === "toaddress") {
      setToaddress(place.formatted_address);
    }
  };

  useEffect(() => {
    setForm({ ...form, extraFields: { fromaddress, toaddress } });
  }, [fromaddress, toaddress]);

  const onDateChange = (date, field) => {
    setForm({
      ...form,
      extraFields: {
        ...form.extraFields,
        [field]: date,
      },
    });
    setMoveDate(date);
  };

  return (
    <div className="transportFewItems">
      <div className="page_banner">
        <img src={bannerImg} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הזמנת הובלה בעזרת נציג</h1>
            <p>נחזור אליכם בהקדם לאחר השארת פרטים</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/transportapartment" />
            <MainBtn
              text="הצעת מחיר אונליין"
              link="/transportonlineaddress"
              isLight={true}
            />
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">פרטים לחזרה</h1>
        <div className="splitDiv">
          <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="שירותי הובלות"
              galleryArr={galleryArr}
            />
          </div>

          <div className="formSide">
            {send ? (
              <PaymentSuccess
                text1="תודה שבחרת בנו!"
                text2="נציג יחזור אליך בהקדם"
              />
            ) : (
              <>
                <Form
                  className="formBox"
                  noValidate
                  validated={validated}
                  onSubmit={handleSend}
                >
                  <WhereAndWhen
                    handleOnPlaceSelected={handleOnPlaceSelected}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        extraFields: {
                          ...form.extraFields,
                          [e.target.name]: e.target.value,
                        },
                      })
                    }
                    onDateChange={onDateChange}
                    moveDate={moveDate}
                  />

                  <Row className="mb-3 row">
                    <Form.Group className="mb-3" controlId="formBasicName">
                      <Form.Label className="fw-semibold mb-2">
                        סוג הובלה
                      </Form.Label>
                      <Form.Select
                        required
                        onChange={(e) =>
                          setForm({
                            ...form,
                            extraFields: {
                              ...form.extraFields,
                              [e.target.name]: e.target.value,
                            },
                          })
                        }
                        name="appartment"
                        // style={{ marginRight: "12px", width: "32.2vw" }}
                      >
                        <option value="">בחר סוג הובלה</option>
                        <option value="1">דירת חדר</option>
                        <option value="2">2 חדרים</option>
                        <option value="3">3 חדרים</option>
                        <option value="4">4 חדרים</option>
                        <option value="5">5 חדרים</option>
                        <option value="6">6 חדרים</option>
                        <option value="7">7 חדרים</option>
                        <option value="penthouse">פנטהאוז</option>
                        <option value="private home">בית פרטי</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        נא לבחור סוג הובלה
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <PersonalDetails
                    onChange={(field) => setForm({ ...form, ...field })}
                  />

                  {/* <div className="contact-btnDiv row">
                    <MainBtn text="שליחה" handleSend={handleSend} />
                  </div> */}
                  <Button
                    style={{
                      background: "var(--primary)",
                      border: "none",
                      width: "100%",
                    }}
                    text="שליחה"
                    type="submit"
                    className="filter-btn"
                  >
                    שליחה
                  </Button>
                </Form>
              </>
            )}
          </div>
        </div>
      </div>

      <Reviews />
      <Footer />
    </div>
  );
};

export default TransportGetBack;
